import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { MsalProvider } from '@azure/msal-react';

import { GOOGLE_CLIENT_ID } from '@/config';
import { getMsalInstance } from '@/config/msal';

type SsoProvidersProps = {
    children: React.ReactNode;
};

export const SsoProviders = ({ children }: SsoProvidersProps) => {
    if (!GOOGLE_CLIENT_ID) {
        return <>{children}</>;
    }

    const msalInstance = getMsalInstance();

    const content = (
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            {children}
        </GoogleOAuthProvider>
    );

    if (!msalInstance) {
        return content;
    }

    return <MsalProvider instance={msalInstance}>{content}</MsalProvider>;
};
